      
      
import { useRef, useState } from 'react'

const PEEK = 120

const maxHeight = () => {
  const chips = document.querySelector('.gm-chips')
  const top = chips ? chips.getBoundingClientRect().bottom + 8 : 0
  return Math.round(
    Math.min(window.innerHeight * 0.9, window.innerHeight - top),
  )
}

export default function useBottomSheet(
  enabled,
  halfRatio,
  startAtPeek = false,
) {
  const initial = enabled && startAtPeek ? PEEK : null
  const [height, setHeight] = useState(initial)
  const [dragging, setDragging] = useState(false)
  const drag = useRef(null)

  const snaps = () => [
    PEEK,
    Math.min(Math.round(window.innerHeight * halfRatio), maxHeight()),
    maxHeight(),
  ]

  const onPointerDown = (e) => {
    if (!enabled || e.target.closest('button, a, input')) return
    const sheet = e.currentTarget.closest('[data-sheet]')
    if (!sheet) return
    drag.current = {
      startY: e.clientY,
      startH: sheet.getBoundingClientRect().height,
      lastY: e.clientY,
      lastT: e.timeStamp,
      vy: 0,
    }
    e.currentTarget.setPointerCapture(e.pointerId)
    setDragging(true)
  }

  const onPointerMove = (e) => {
    const d = drag.current
    if (!d) return
    d.vy = (e.clientY - d.lastY) / Math.max(1, e.timeStamp - d.lastT)
    d.lastY = e.clientY
    d.lastT = e.timeStamp
    const [min, , max] = snaps()
    setHeight(
      Math.min(max, Math.max(min * 0.6, d.startH + d.startY - e.clientY)),
    )
  }

  const onPointerUp = (e) => {
    const d = drag.current
    if (!d) return
    drag.current = null
    setDragging(false)
    const s = snaps()
    const current = d.startH + d.startY - e.clientY
    let target
    if (Math.abs(current - d.startH) < 5) {
      target = d.startH < s[2] - 10 ? s[2] : s[1]
    } else if (Math.abs(d.vy) > 0.5) {
      target =
        d.vy < 0
          ? (s.find((x) => x > current + 1) ?? s[2])
          : ([...s].reverse().find((x) => x < current - 1) ?? s[0])
    } else {
      target = s.reduce((a, b) =>
        Math.abs(b - current) < Math.abs(a - current) ? b : a,
      )
    }
    setHeight(target)
  }

  return {
    sheetStyle:
      enabled && height
        ? {
            height,
            transition: dragging ? 'none' : 'height 0.3s var(--gm-ease)',
          }
        : undefined,
    grabProps: enabled
      ? {
          onPointerDown,
          onPointerMove,
          onPointerUp,
          onPointerCancel: onPointerUp,
          style: { touchAction: 'none', cursor: 'grab' },
        }
      : {},
    resetSheet: () => setHeight(initial),
    openHalf: () =>
      enabled &&
      setHeight(
        Math.min(Math.round(window.innerHeight * halfRatio), maxHeight()),
      ),
  }
}

    

    